import { useNavigate } from "react-router-dom";
import React, { useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Stack from "@mui/material/Stack";

import Search from "../Search/Search";
import Title from "../../common/Title";
import BatchList from "../../common/BatchList";

import useBatchListState from "../../../hooks/useBatchListState";
import { OPERATIONS } from "../../../constants/value";
import { __getUpdateNumberBatches } from "../../../api/sim";

const UpdateNumber = ({ client }) => {
  const nav = useNavigate();

  const [searchActive, setSearchActive] = useState(false);

  const {
    data,
    loading,
    metaData,
    response,
    statusCategories,
    handlePageChange,
    handlePageSizeChange,
    handleStatusCategoryChange,
  } = useBatchListState(__getUpdateNumberBatches, { client });

  return (
    <Box sx={{ width: "100%" }}>
      <Title
        variant="h5"
        sx={{ textTransform: "capitalize" }}
        content={`${client ? client : ""} Update Number`}
        gutterBottom
      />
      <Search
        key={`${client}-updateNumber`}
        client={client}
        operation={OPERATIONS.update_number}
        searchActive={searchActive}
        setSearchActive={setSearchActive}
      />

      {/* if search not active show as desired */}

      {!searchActive &&
        (response ? (
          <>
            <Grid container justifyContent="flex-start" spacing={2}>
              <Grid item>
                <Stack spacing={2} direction="row">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => nav("form")}
                  >
                    {`Update Number`}
                  </Button>
                </Stack>
              </Grid>
            </Grid>
            <BatchList
              data={data}
              loading={loading}
              meta={metaData}
              statusCategories={statusCategories}
              onStatusCategoryChange={handleStatusCategoryChange}
              handlePageChange={handlePageChange}
              handlePageSizeChange={handlePageSizeChange}
            />
          </>
        ) : (
          <Title content="Please wait..." variant="subtitle2" gutterBottom />
        ))}
    </Box>
  );
};

export default UpdateNumber;
